<template>
  <v-bottom-sheet
    v-model="isOffline"
    persistent
  >
    <v-sheet
      class="text-center pt-2 pb-2"
      tile
    >
      <div class="py-3">
        <v-icon
          class="mt-2 mb-5"
          color="red"
          size="40px"
        >far fa-wifi-slash</v-icon>
        <h3>{{ $t('There is no internet connection') }}</h3>
        <p>{{ $t('Your computer is offline') }}</p>
        <p>{{ $t('Try') }}:
          <ul class="list-unstyled mt-2">
            <li>{{ $t('Checking the network cable or router') }}</li>
            <li>{{ $t('Resetting the modem or router') }}</li>
            <li>{{ $t('Reconnecting to Wi-Fi') }}</li>
          </ul>
        </p>
      </div>
      <v-progress-linear
        class="mb-3"
        color="black"
        height="2"
        indeterminate
        style="width:300px; margin: auto"
      />
    </v-sheet>
  </v-bottom-sheet>
</template>
<script>
import { mapState } from 'vuex'
const EVENTS = ['online', 'offline', 'load']

export default {
  name: 'ConnectionChecker',

  computed: {
    ...mapState(['isOnline']),
    isOffline () {
      return !this.isOnline
    }
  },

  created () {
    EVENTS.forEach(event => window.addEventListener(event, this.updateOnlineStatus))
  },

  beforeDestroy () {
    EVENTS.forEach(event => window.removeEventListener(event, this.updateOnlineStatus))
  },

  methods: {
    updateOnlineStatus () {
      const isOnline = navigator.onLine || false
      this.$store.dispatch('SET_ONLINE', isOnline)
    }
  }
}
</script>
